import type { CreativeProject } from "./domain";

const now = new Date().toISOString();

export const seedProjects: CreativeProject[] = [
  {
    id: "moonlit-garden",
    title: "The Moonlit Garden",
    workType: "Fiction",
    status: "active",
    originalLanguage: "si-LK",
    creationMethod: "tell",
    audience: "Adults and families",
    tone: "Warm and reflective",
    tones: ["Warm", "Moving"],
    feelings: ["Wonder", "Belonging"],
    customTone: "",
    customFeeling: "",
    emotionalDirection: "",
    assistanceLevel: "Help me improve it",
    preserveWording: true,
    preserveCulture: true,
    collaborationAnswers: emptyCollaborationAnswers(),
    originalInput:
      "සඳ එළිය වැටුණු වත්තේ පැරණි අඹ ගස යට මාලනී කතාවක් පටන් ගත්තා.",
    workingText:
      "සඳ එළිය වැටුණු වත්තේ, පැරණි අඹ ගස යට මාලනී තම පවුලේ අමතක වූ කතාවක් පටන් ගත්තා. සුළඟ සමඟ කොළ සෙමින් සෙලවුණා. ඇගේ වචනවලින් ගෙදර මතක නැවත ජීවත් වුණා.",
    versions: [
      {
        id: "mg-v1",
        number: 1,
        name: "The story begins",
        text: "සඳ එළිය වැටුණු වත්තේ පැරණි අඹ ගස යට මාලනී කතාවක් පටන් ගත්තා.",
        createdAt: "2026-07-20T10:00:00.000Z",
        reason: "initial",
      },
      {
        id: "mg-v2",
        number: 2,
        name: "Family memories added",
        text:
          "සඳ එළිය වැටුණු වත්තේ, පැරණි අඹ ගස යට මාලනී තම පවුලේ අමතක වූ කතාවක් පටන් ගත්තා. සුළඟ සමඟ කොළ සෙමින් සෙලවුණා. ඇගේ වචනවලින් ගෙදර මතක නැවත ජීවත් වුණා.",
        createdAt: now,
        reason: "saved",
      },
    ],
    editions: [
      {
        id: "mg-en",
        language: "en-GB",
        label: "English edition",
        text:
          "In the moonlit garden, beneath the old mango tree, Malani began a forgotten family story. The leaves moved softly in the breeze, and home came alive again through her words.",
        sourceVersionId: "mg-v2",
        approach: "Sample content",
      },
    ],
    storyboards: [
      {
        id: "mg-comic",
        title: "The Moonlit Garden — storyboard",
        sourceVersionId: "mg-v2",
        scenes: [
          {
            id: "scene-1",
            title: "A story under the mango tree",
            setting: "A quiet family garden under a full moon",
            emotion: "Warm anticipation",
            panels: [
              {
                id: "panel-1",
                visual:
                  "Wide view of an old mango tree, silver moonlight, and a woman seated with her family.",
                narration: "The garden held its breath as Malani began.",
              },
              {
                id: "panel-2",
                visual:
                  "Close view of leaves moving while the family leans closer.",
                narration: "The old memories returned, one word at a time.",
                speaker: "Malani",
                dialogue: "This story began long before any of us were born.",
              },
            ],
          },
        ],
      },
    ],
    updatedAt: now,
  },
  {
    id: "river-notes",
    title: "Notes from the River",
    workType: "Non-fiction",
    status: "active",
    originalLanguage: "en-GB",
    creationMethod: "write",
    audience: "General readers",
    tone: "Quiet and hopeful",
    tones: ["Gentle", "Inspirational"],
    feelings: ["Calm", "Curiosity"],
    customTone: "",
    customFeeling: "",
    emotionalDirection: "",
    assistanceLevel: "Develop my ideas",
    preserveWording: true,
    preserveCulture: true,
    collaborationAnswers: emptyCollaborationAnswers(),
    originalInput: "Memories of walking beside the river after the first rain.",
    workingText:
      "After the first rain, the river path carried the scent of wet earth. Each bend held a small memory: a kingfisher, a neighbour's greeting, a stone warmed by yesterday's sun.",
    versions: [
      {
        id: "rn-v1",
        number: 1,
        name: "First reflection",
        text:
          "After the first rain, the river path carried the scent of wet earth. Each bend held a small memory.",
        createdAt: now,
        reason: "initial",
      },
    ],
    editions: [],
    storyboards: [],
    updatedAt: now,
  },
];

function emptyCollaborationAnswers() {
  return {
    centre: "",
    change: "",
    challenge: "",
    ending: "",
    preserveExactly: "",
  };
}

export const emptyProjectDraft = (): NewProjectDraft => ({
  workType: "Not sure yet",
  audience: "",
  tones: [],
  feelings: [],
  customTone: "",
  customFeeling: "",
  emotionalDirection: "",
  assistanceLevel: "Help me improve it",
  originalLanguage: "und",
  languageManuallySelected: false,
  preserveWording: true,
  preserveCulture: true,
  idea: "",
  stage: "capture",
  savedAt: "",
  suggestedFields: [],
  collaborationAnswers: emptyCollaborationAnswers(),
});

import type { NewProjectDraft } from "./domain";
